import { render, staticRenderFns } from "./WeightAgeChart.vue?vue&type=template&id=4862c29e&"
import script from "./WeightAgeChart.vue?vue&type=script&lang=ts&"
export * from "./WeightAgeChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports